import { forwardRef } from "react";
import type { InputHTMLAttributes } from "react";

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(function Input(
  { className = "", ...props },
  ref
) {
  return (
    <input
      ref={ref}
      className={`w-full bg-ink-900 border border-ink-700 rounded-md px-3 py-2 text-sm placeholder:text-muted/50 transition-colors focus:border-ledger-500 ${className}`}
      {...props}
    />
  );
});
